export default "__VITE_ASSET__DZvrw3hd__"